<template>
    <div>
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="HubspotRequest" v-bind:style="{ background: [getBackgroundColor()]}">
            <div class="Request_wrapper">
                <div class="content">
                    <div class="inner-content">
                        <div class="place">
                            <div class="place_img">
                                <img src="@/assets/images/royal_flush_logo.png" alt="place img">
                            </div>
                        </div>
                        <div class="main_title">{{ requestType == 'new' ? 'Submit new lead' : 'Submit existing lead' }}</div>
                        <div class="input-wrapper name" v-if="requestType == 'existing'">
                            <b-form-input type="text" placeholder=" " ref="name_input" class="form-control"
                                          v-model="siteId"></b-form-input>
                            <label class="input-label">Site ID</label>
                        </div>
                        <div class="input-wrapper name" v-if="requestType == 'new'">
                            <b-form-input type="text" placeholder=" " ref="name_input" class="form-control"
                                          v-model="companyName"></b-form-input>
                            <label class="input-label">Company name</label>
                        </div>
                        <div class="input-wrapper name" v-if="requestType == 'new'">
                            <b-form-input type="text" placeholder=" " ref="name_input" class="form-control"
                                          v-model="contactInfo"></b-form-input>
                            <label class="input-label">Contact info</label>
                        </div>
                        <div class="input-wrapper additional" v-if="requestType == 'new'">
                            <label class="dropdown-label">Rental use</label>
                            <b-dropdown
                                :text="rentalUse == '' ? 'Choose rental use' : rentalUse"
                                class="additional-dropdown"
                                toggle-class="additional-dropdown-toggle">
                                <b-dropdown-item v-for="item in rentalUseOptions" :key="item.id"
                                                 v-on:click="rentalUse = item; refreshValidation()">
                                    <span> {{ item }}</span>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="input-wrapper notes">
                            <b-form-textarea type="text" placeholder=" " ref="notes_input"
                                             rows="3" max-rows="3" no-resize
                                          v-model="notes"></b-form-textarea>
                            <label class="input-label"
                                   :class="{ta: notes != ''}">Notes</label>
                            <input
                                style="display: none"
                                type="file"
                                @change="onFileSelected"
                                ref="fileInput"
                                accept="image/png, image/jpeg"
                                multiple>
                        </div>
                        <div class="note__buttons">
                            <div class="addContent__btn" @click="onAttachClick" v-if="true">
                                <img src="@/assets/icons/ic_photo.svg" alt="">
                            </div>
                            <div class="addContent__btn audio" @click="onAudioBtnClick">
                                <recordAudioBtn :settings="recordAudioBtnSettings"></recordAudioBtn>
                            </div>
                        </div>
                        <div class="preview" v-if="files.length > 0">
                            <img v-for="(item, index) in files"
                                 :key="index"
                                 :src="item.url"
                                 @click="onFileClick(item)"/>
                        </div>
                        <div class="audio_wrapper" id='audio' v-for="(item, index) in recordedAudio" :key="index">
                            <!--                            <img :src="item.url"/>-->
                            <audio controls='controls' v-if="recordedAudio.length > 0">
                                <source :src="audioLink">
                            </audio>
                            <div class="audio_delete" id="audio_delete" v-if="recordedAudio.length > 0"
                                 @click="deleteAudioClick">
                                <img src="@/assets/icons/ic_trash.svg" alt="">
                            </div>
                        </div>
                        <div class="input-wrapper submitted_by">
                            <b-form-input type="text" ref="name_input" placeholder=" " class="form-control"
                                          v-model="submittedBy"></b-form-input>
                            <label class="input-label">Submitted by</label>
                        </div>
                        <div class="main_button"
                             v-bind:style="{ background: [this.inputIsValid ? getPrimaryColor() : getButtonInactiveColor() ]}"
                             @click="onSendClick">
                            <div>Submit</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="popupModal" :class="{active: selectedFile != null}">
            <div class="popupModal__wrapper" @mousedown='underlayClick'>
                <div class="popupModal__content" id="popupModal__content">
                    <div class="close-icon__wrapper">
                            <span class="close-icon" @click="selectedFile = null">
                                <img src="@/assets/icons/ic_close_white.svg">
                            </span>
                    </div>
                    <div class="photo-modal__wrapper">
                        <div class="photo-modal__image">
                            <img v-if="selectedFile" :src="selectedFile.url"/>
                        </div>
                    </div>
                    <div class="photo-modal__buttons">
                        <div class="photo-modal__delete" @click="onDeleteImageClick">
                            {{ translate('RemovePhoto') }}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import geoLocationMixin from "@/mixins/geoLocationMixin";
import errorMixin from '@/mixins/errorMixin';
import {mapActions, mapMutations, mapState} from 'vuex';
import customModalDialog from '@/components/widgets/customModalDialog';
import profileIconNew from "./voteFlow/widgets/profileIconNew.vue";
import recordAudioBtn from "@/components/widgets/recordAudioBtn.vue";
import logAnalyticsEvent from '@/helpers/analytics'
import "@/assets/css/popapModal.css";

export default {
    mixins: [mixin, geoLocationMixin, errorMixin],
    components: {
        customModalDialog, profileIconNew, recordAudioBtn,
    },
    data() {
        return {
            requestType: 'new',
            placeGuid: null,
            fullConfig: null,
            config: {},
            place_img: '',
            inputIsValid: false,
            notes: '',
            siteId: '',
            companyName: '',
            contactInfo: '',
            submittedBy: '',
            phone: '',
            rentalUse: '',
            rentalUseOptions: [
                'Construction',
                'Event',
                'Municipalities',
                'Production',
                'Seasonal',
                'Transit Authorities',
                'Utilities',
            ],
            recordInProgress: false,

            recordAudioBtnSettings: {
                recordInProgressBool: this.recordInProgress,
                // startRecord: this.recordAudio,
                // stopRecord: this.stopRecordAudioClick
            },

            userLocation: {
                lat: 0,
                lng: 0,
                accuracy: 0
            },
            files: [],
            photoSize: 20, // megabytes
            maxFiles: 5,
            selectedFile: null,
            customModalSettings: {},
            recorder: null,
            mediaStream: null,
            recordedAudio: [],
            audioLink: null,
        }
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        })
    },
    watch: {
        'companyName'(value) {
            this.refreshValidation()
        },
        'siteId'(value) {
            this.refreshValidation()
        },
        'contactInfo'(value) {
            this.refreshValidation()
        },
        'rentalUse'(value) {
            this.refreshValidation()
        },
        'notes'(value) {
            this.refreshValidation()
        },
        'submittedBy'(value) {
            this.refreshValidation()
        },
        'recordedAudio'(value) {
            this.refreshValidation()
        },
        'files'(value) {
            this.refreshValidation()
        },
    },
    async mounted() {
        let type = 'new'
        if(this.$route.params.type == 'existing') type = 'existing'
        this.requestType = type
        this.placeGuid = this.$route.params.place_guid
        this.initFetchLocationFlow()
        this.restoreContactInfo()
        // this.focusInputWithTimeout('name_input')
    },
    methods: {
        ...mapMutations({
            setProgressBarTag: 'setProgressBarTag',
        }),
        ...mapActions({
            addLead: 'hubspotLeads/addLead'
        }),

        getBackgroundColor() {
            if (this.config.background) return this.config.background
            if (this.requestType == 'pickup') {
                return '#ECAEAE'
            } else if (this.requestType == 'swap') {
                return '#7AC682'
            } else {
                return '#7AC682'
                // return '#d5d5d5'
            }
        },
        getPrimaryColor() {
            if (this.config.primary_color) return this.config.primary_color
            if (this.requestType == 'pickup') {
                return '#B95E5E'
            } else if (this.requestType == 'swap') {
                return '#48624B'
            } else {
                return '#48624B'
                // return '#7d7d7d'
            }
        },
        getButtonInactiveColor() {
            if (this.config.button_inactive_back) return this.config.button_inactive_back
            if (this.requestType == 'pickup') {
                return '#BF9595'
            } else if (this.requestType == 'swap') {
                return '#646B65'
            } else {
                return '#646B65'
                // return '#a8a8a8'
            }
        },
        showLogo() {
            if (this.config.hasOwnProperty('show_logo')) return this.config.show_logo
            return true
        },
        imgAspectRatio() {
            if (this.config.img_aspect_ratio) return this.config.img_aspect_ratio
            return 1
        },

        catchOpenSelect() {
            let select = document.getElementById('drivers')
            console.log(select)
        },

        applyCurrentConfig() {
            var config = this.fullConfig[this.requestType] ? this.fullConfig[this.requestType] : {}
            if(config.additional_fields) {
                config.additional_fields = config.additional_fields.sort(function (q1, q2) {
                    return q1.order - q2.order;
                });
            }
            this.config = config
            this.refreshValidation()
        },
        async initFetchLocationFlow() {
            try {
                let position = await this.fetchUserLocation(30000)
                this.userLocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                }
            } catch (e) {
                console.log(`kek error:`, e)
                if (e.code == e.PERMISSION_DENIED) {
                    console.log(`kek error:`, e)
                }
            }
        },
        onFileSelected(event) {
            console.log(`onFileSelected files:`, event.target.files)
            for (let i = 0; event.target.files.length > i; i++) {
                let selectedFile = event.target.files[i];
                if (selectedFile.type != 'image/png' && selectedFile.type != 'image/jpeg') {
                    this.showErrorModal(this.translate('WrongFormat'))
                } else if ((selectedFile.size >= (this.photoSize * 1048576))) {
                    this.showErrorModal(this.translate('PhotoOverweight', [this.photoSize]))
                } else {
                    if (this.files.length == this.maxFiles) {
                        this.$refs.fileInput.value = ''
                        this.showErrorModal(this.translate('max_attach_photos_count_error', [this.maxFiles]))
                        return
                    }
                    this.files.push({
                        file: selectedFile,
                        url: URL.createObjectURL(selectedFile)
                    })
                }
            }
            this.$refs.fileInput.value = ''
        },
        onAttachClick() {
            if (this.files.length < this.maxFiles) this.$refs.fileInput.click()
        },
        onFileClick(item) {
            this.selectedFile = item
        },
        submitCheck() {
            console.log(this.driverInfo)
        },
        focusInputWithTimeout(ref) {
            setTimeout(() => {
                this.$refs[ref].focus()
            }, 200);
        },
        onDeleteImageClick() {
            if (this.selectedFile == null) return
            this.files = this.files.filter(item => {
                return item.url != this.selectedFile.url
            })
            this.selectedFile = null
        },
        underlayClick(e) {
            if (this.isClickOutOfBlock('popupModal__content', e.target)) {
                console.log(`underlayClick`)
                this.selectedFile = null
            }
        },
        onAudioBtnClick() {
            if(this.recordInProgress) {
                this.stopRecordAudioClick()
            } else {
                this.recordAudio()
            }
        },
        recordAudio() {
            if(this.recordInProgress) return
            logAnalyticsEvent('al_audio_rec_clk')
            let device = navigator.mediaDevices.getUserMedia({audio: true});
            device.then((stream) => {
                this.recorder = new MediaRecorder(stream);
                this.mediaStream = stream
                this.recordInProgress = true
                this.recordAudioBtnSettings.recordInProgressBool = true
                this.recordAction()
                this.recorder.start();
                setTimeout(() => {
                    this.stopRecording()
                }, 60000);
            })
        },
        recordAction() {
            if (this.recordedAudio.length > 0) {
                this.recordedAudio.shift()
            }
            this.recorder.ondataavailable = (e) => {
                this.recordedAudio.push(e.data)
                let blob = new Blob(this.recordedAudio, {type: this.recorder.mimeType,});
                this.audioLink = URL.createObjectURL(blob)
            };
        },
        stopRecordAudioClick() {
            logAnalyticsEvent('al_audio_rec_stop_clk')
            this.stopRecording()
        },
        stopRecording() {
            this.recordInProgress = false
            this.recordAudioBtnSettings.recordInProgressBool = false
            this.recorder.stop();
            if (this.mediaStream) this.mediaStream.getTracks().forEach(track => track.stop());
        },
        deleteAudioClick() {
            logAnalyticsEvent('al_audio_rec_remove_clk')
            this.recordedAudio.shift()
        },

        refreshValidation() {
            this.inputIsValid = this.recordInProgress
                || this.companyName != ''
                || this.siteId != ''
                || this.contactInfo != ''
                || this.notes != ''
                || this.recordedAudio.length > 0
                || this.files.length > 0
        },

        async onSendClick() {
            if (!this.inputIsValid) {
                // this.showErrorModal(this.translate('airLeadPleaseCompanyInfo'), {duration: 1000})
                return
            }
            if (this.recordInProgress) {
                this.stopRecording()
            }

            if(this.submittedBy == '') {
                this.showErrorModal('Please enter your name')
                return
            }


            const body = {
                placeGuid: this.placeGuid,
                company_name: this.companyName,
                site_id: this.siteId,
                contact_info: this.contactInfo,
                rental_use: this.rentalUse,
                notes: this.notes,
                submitted_by: this.submittedBy,
                type: this.requestType,
                location: this.userLocation,
                images: this.files.map(item => item.file),
                audio: this.recordedAudio.length > 0 ? new Blob(this.recordedAudio, {type: this.recorder.mimeType,}) : null,
            }
            try {
                this.saveContactInfo()
                this.setProgressBarTag({
                    show: true,
                    tag: 'add_service_request'
                })
                const response = await this.addLead(body)
                this.$router.push({name: 'HubspotRequestSuccess'});
            } catch (error) {
                console.log(error)
                if(error.data.error.code == 1224) {
                    this.showErrorModal("Something went wrong. Please try again or contact support")
                } else if(error.data.error.code == 1225) {
                    this.showErrorModal("Something went wrong. Please try again or contact support")
                } else {
                    this.showErrorModal(error.data.error.message)
                }
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'add_service_request'
                })
            }
        },
        getSuccessText() {
            return this.config.success_text ? this.config.success_text : this.translate('serviceRequest_successText')
        },
        saveContactInfo() {
            localStorage.setItem('ah_submittedBy', this.submittedBy)
        },
        restoreContactInfo() {
            let name = localStorage.getItem('ah_submittedBy')
            this.submittedBy = name ? name : ''
        },
    }

}
</script>

<style>
.dropdown-menu {
    z-index: 9999999 !important;
}

.HubspotRequest .comment_btn__wrapper.audio {
    position: relative;
    right: auto;
    bottom: auto;
}
.HubspotRequest .comment_btn__wrapper.audio img {
    width: 22px;
    height: 22px;
}
.HubspotRequest  .spin {
    position: relative;
    right: auto;
    bottom: auto;
    left: 0;
    top: 0;
}

.HubspotRequest #container {
    bottom: -2px;
}

.HubspotRequest .spin {
    bottom: 5px;
    right: 40px;
}

.additional-dropdown {

}
.additional-dropdown li {
    width: 100%;
}
.additional-dropdown-toggle {
    background: white !important;
    border: 1px solid black;
    color: black !important;
}
.additional-dropdown-toggle::after {
    margin-left: 10px;
}


</style>
<style scoped>
.HubspotRequest {
    display: flex;
    min-height: 100vh;
}

.Request_wrapper {
    margin-left: 16px;
    margin-right: 16px;
    margin-top: 16px;
    margin-bottom: 16px;
    width: 100%;
    display: flex;
}

.content {
    max-width: 500px;
    width: 100%;
    position: initial;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.inner-content::-webkit-scrollbar {
    display: none;
}

.inner-content {
    background: white;
    border-radius: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
}

.place_img {
    width: auto;
    height: 70px;
    margin-top: 24px;
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
}

.place_img img {
    width: auto;
    height: 70px;
    object-fit: cover;
}

.main_title {
    margin-top: 18px;
    margin-bottom: 8px;
    font-size: 18px;
    margin-left: 24px;
    margin-right: 24px;
    text-align: center;
}

.profile-photo {
    align-self: end;
    position: absolute;
    width: 36px;
    height: 36px;
    top: 12px;
    right: 12px;
}

.main_button {
    background: #B95E5E;
    border-radius: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 16px;
    margin-top: 12px;
    color: white;
    height: 44px;
    min-height: 44px;
    display: flex;
    font-size: 18px;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 4px 0 rgb(0 0 0 / 30%);
    cursor: pointer;
    max-width: 400px;
}

.input-wrapper {
    margin-left: 16px;
    margin-right: 16px;
    width: auto;
}

.input-wrapper.notes {
    margin-top: 16px;
}

.input-wrapper.notes .form-control {
    padding-right: 0px;
}

.input-wrapper.name {
    margin-top: 18px;
}

.input-wrapper.submitted_by {
    margin-top: 24px;
}

.input-wrapper.additional {
    display: flex;
    flex-direction: column;
}
.input-wrapper .dropdown-label {
    font-size: 14px;
}

.confirm_charge {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 16px;
    margin-right: 16px;
    font-size: 15px;
}

.confirm_charge span {
    margin-left: 4px;
    margin-top: 5px;
    width: 100%;
    cursor: pointer;
}

.comment_btn__wrapper.photo {
    position: absolute;
    right: 8px;
    bottom: 7px;
    cursor: pointer;
}

.preview {
    height: 50px;
    padding-top: 4px;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 10px;
}

.preview img {
    max-width: 100%;
    max-height: 50px;
    padding-right: 5px;
}

.audio_wrapper {
    margin-top: 10px;
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-left: 16px;
    margin-right: 16px;
}

audio {
    width: 90%;
    height: 40px;
}

.audio_delete {
    margin-left: 6px;
    cursor: pointer;
    padding: 6px;
}

.note__buttons {
    display: flex;
    flex-direction: row;
    margin-left: 16px;
    margin-right: 16px;
    gap: 16px;
}

.addContent__btn {
    cursor: pointer;
    border: 1px solid black;
    border-radius: 6px;
    width: 85px;
    padding: 5px;
    display: flex;
    height: 46px;
    max-height: 46px;
    justify-content: center;
    align-items: center;
    flex: 1;
}

.addContent__btn img {
    width: 25px;
    height: 25px;
}
.addContent__btn.audio-stop {
    width: 20px;
    height: 20px;
    font-size: 0;
    background-color: red;
    border: 0;
    border-radius: 35px;
    outline: none;
    cursor: pointer;
    display: none;
}
.addContent__btn.audio-stop.active {
    display: block;
    animation-name: pulse;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}
/*________*/


input[type="checkbox"] {
    width: auto;
    margin-left: 0;
}

.input-label.dropdown {
    top: -14px !important;
    transition: all .3s ease;
    font-size: 14px;
}

.input-label {
    position: absolute;
    z-index: 999;
    top: 10px;
    pointer-events: none;
    transition: all .3s ease;
}

input:not(:placeholder-shown) ~ .input-label,
input:focus ~ .input-label {
    top: -15px;
    transition: all .3s ease;
    font-size: 14px;
}
.input-label.ta  {
    top: -15px;
    transition: all .3s ease;
    font-size: 14px;
}

.form-control {
    position: relative;
    border: none;
    border-bottom: 1px solid #2F2F2F;
    outline: none;
    border-radius: 0;
    padding-left: 0;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
    color: black;
}

.form-control:focus {
    outline: none !important;
    text-decoration: none;
    box-shadow: none;
    border-color: #2F2F2F;
    color: black;
}

input::-webkit-calendar-picker-indicator {
    display: none;
}

.form-control::placeholder {
    font-size: 14px;
    color: #2F2F2F;
}

.form-control.simple::placeholder {
    font-size: 16px;
    color: #cdcdcd;
}

.form-control.simple {
    margin-top: 4px;
}

.photo-modal__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.photo-modal__image img {
    max-width: 100%;
    max-height: 250px;
}

.photo-modal__buttons {
    display: flex;
    justify-content: center;
    margin-top: 35px;
}

.photo-modal__change {
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-right: 25px;
}

.photo-modal__delete {
    width: 100%;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    cursor: pointer;
    color: #FFFFFF;
    background-color: #3F405C;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

@media screen and (min-width: 532px) {
    .content {
        margin: auto;
    }
}

@media screen and (min-width: 464px) {
    .main_button {
        margin-left: auto;
        margin-right: auto;
        min-width: 400px;
    }
}

@keyframes pulse {
    0% {
        box-shadow: 0px 0px 5px 0px rgba(173, 0, 0, .3);
    }
    65% {
        box-shadow: 0px 0px 5px 10px rgba(173, 0, 0, .3);
    }
    90% {
        box-shadow: 0px 0px 5px 10px rgba(173, 0, 0, 0);
    }
}
</style>
